import { transformDateValue } from 'core/js/FormUtils';
export const getMlmorderView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mlmorderList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Order Value","fieldValue":transformDataValue(data.ordervalue,"double"), "fieldType":"double"},
                            {"fieldLabel":"Partner Id","fieldValue":transformDataValue(data.partnerid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Member Id","fieldValue":transformDataValue(data.memberid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Order Date","fieldValue":transformDataValue(data.orderdate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Credit Value","fieldValue":transformDataValue(data.creditvalue,"double"), "fieldType":"double"},
                            {"fieldLabel":"Address Id","fieldValue":transformDataValue(data.addressid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Cart Id","fieldValue":transformDataValue(data.cartid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Delivery Status Id","fieldValue":transformDataValue(data.deliverystatusid,"number"), "fieldType":"number"},
                            {"fieldLabel":"Payment Id","fieldValue":transformDataValue(data.paymentid,"string"), "fieldType":"string"},
                            {"fieldLabel":"Origin Id","fieldValue":transformDataValue(data.originid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Payment Order Id","fieldValue":transformDataValue(data.paymentorderid,"string"), "fieldType":"string"},
                            {"fieldLabel":"Dispatched On","fieldValue":transformDataValue(data.dispatchedon,"date"), "fieldType":"date"},
                            {"fieldLabel":"Remarks","fieldValue":transformDataValue(data.remarks,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mlmorderList.push(card);
  })
  return mlmorderList;
}